mutation RestoreInternalExpenses($ids: [ID!]!) {
  restoreInternalExpenses(ids: $ids) {
    id
    deletedAt
  }
}
